const DAYJS_MONTH_OFFSET = 1; // dayjs.month() returns 0-11

export const getMonthFromDayjsMonth = (dayjsMonth: number) => dayjsMonth + DAYJS_MONTH_OFFSET;
